import React from 'react';
import { get } from 'lodash';
import Audios from './Audios';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Divider from '../../../../core/layout/Divider';
import TextInput from '../../../../core/form/TextInput';
import SlicesInputContainer from './SlicesInputContainer';
import ErrorText from '../../../../core/layout/ErrorText';
import Button from '../../../../core/form/Button';
import Table from '../../../../core/form/Table';
import ColumnSeparator from '../../../../core/layout/ColumnSeparator';
import AudioPreview from '../../../../core/layout/AudioPreview';

const GrammarCheckAnswersInput = (props) => (
  <>
    <Divider title="Answers" />
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Answer text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    <SlicesInputContainer
      onChange={(answerSlices) => {
        const slices = answerSlices.map((slice) => ({
          word: slice.text || slice.word,
          index: slice.index,
          ...(slice.linkTo && { linkTo: slice.linkTo }),
        }));
        props.onChange('slices', slices);
        props.onChange(
          'answerIndexesToRemove',
          answerSlices.filter((slice) => slice.index !== undefined)
        ); // this is to show errors
      }}
      text={get(props.values, 'text', '')}
      value={get(props.values, 'slices', [])}
      errorText={get(props.errors, 'slices', '')}
      label="Which word or expression is correct in this sentence comparing with original sentence:"
      allowLinkSlices
      disabled={props.disabled}
      color="#53be5e"
    />
    <Row>
      <Column size={12}>
        <Audios
          audioPath="audio"
          generatedAudioPath="generatedAudio"
          values={props.values}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <Button
          icon="check"
          type="primary"
          label={props.values.id ? 'Update' : 'Add'}
          disabled={!props.isDirty()}
          onClick={() => props.onSubmit()}
        />
        <ColumnSeparator size="xs" />
        <Button icon="reload" label="Discard" onClick={() => props.onReset()} />
      </Column>
    </Row>
    <ColumnSeparator size="xs" />
    <Row>
      <Column size={12}>
        <Table
          columns={[
            {
              label: 'Answer Text',
              path: 'text',
            },
            {
              label: 'Correct word or expression',
              path: 'slices',
              render: (cell, row) => get(row, 'slices', []).map(({ word }) => `${word} `),
            },
            {
              label: 'Generated Audio',
              path: 'generatedAudio',
              width: '80px',
              render: (cell, row) => {
                if (row.generatedAudio) {
                  return <AudioPreview src={row.generatedAudio} />;
                }
                return '-';
              },
            },
            {
              label: 'Audio',
              path: 'audio',
              width: '80px',
              render: (cell, row) => {
                if (row.audio) {
                  return <AudioPreview src={row.audio} />;
                }
                return '-';
              },
            },
            {
              label: 'Actions',
              path: 'action',
              width: '100px',
              render: (cell, row) => (
                <div>
                  <Button icon="delete" onClick={() => props.onDelete(row.id)} />
                  <Button icon="edit" onClick={() => props.onEdit(row.id)} />
                </div>
              ),
            },
          ]}
          rows={get(props, 'answers', [])}
        />
        {props.errorText && <ErrorText>{props.errorText}</ErrorText>}
      </Column>
    </Row>
  </>
);

GrammarCheckAnswersInput.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isDirty: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  errorText: PropTypes.string,
};

GrammarCheckAnswersInput.defaultProps = {
  values: {},
  submitting: false,
  disabled: false,
  errors: {},
  errorText: null,
};
export default GrammarCheckAnswersInput;
